import { ERROR_IMAGE_DOG_DOOR, ERROR_IMAGE_ROBOT_TOYS } from "../constants/image-constants";
export function getSideImageByErrorCode(errorCode) {
  if (errorCode === 401 || errorCode === 403) {
    return ERROR_IMAGE_DOG_DOOR;
  }
  return ERROR_IMAGE_ROBOT_TOYS;
}